import styled from 'styled-components';

export const StyledAppLogo = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;

  & img {
    height: 40px;
    width: auto;
    max-width: min(11.5rem, 42vw);
    object-fit: contain;
    display: block;
    margin-right: 0;

    [dir='rtl'] & {
      margin-right: 0;
      margin-left: 0;
    }
  }
`;
